var _rect, _path, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnHoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 4,
    fill: "#E7E7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48709 4.08446C7.65116 4.01361 7.83083 3.98664 8.00846 4.00618C8.1861 4.02573 8.35561 4.09113 8.50035 4.19595C9.30184 4.78007 9.92592 5.57735 10.4588 6.34028L10.7688 6.79186L11.0612 7.22311C11.3417 7.63262 11.2975 8.18308 10.9588 8.5414L10.8817 8.61573L9.51361 9.63179C9.44769 9.6795 9.40128 9.74946 9.38297 9.82875C9.36466 9.90803 9.3757 9.99127 9.41403 10.063C9.72397 10.6268 10.2751 11.4655 10.9062 12.0966C11.5373 12.7277 12.4159 13.3153 13.0183 13.6603C13.0837 13.6973 13.1597 13.7113 13.234 13.7001C13.3084 13.689 13.3768 13.6532 13.4285 13.5986L13.4699 13.5467L14.3604 12.1912C14.5242 11.9738 14.7657 11.8281 15.0344 11.7847C15.3032 11.7413 15.5783 11.8035 15.8021 11.9584L16.2972 12.302C17.2046 12.9352 18.0972 13.6035 18.783 14.4814C18.8963 14.6272 18.9684 14.8008 18.9918 14.9839C19.0151 15.1671 18.9887 15.3532 18.9155 15.5227C18.3321 16.8838 16.8357 18.0576 15.2987 18.0008L15.0883 17.9896L14.9249 17.9756L14.744 17.9545L14.5469 17.9279L14.3331 17.8921L14.1045 17.8473L13.8619 17.7926L13.6052 17.7274L13.3352 17.6495L13.0534 17.5584C11.7589 17.1201 10.116 16.2576 8.43023 14.5726C6.7445 12.8875 5.8827 11.2439 5.44374 9.94944L5.35258 9.66755L5.27545 9.39759L5.20953 9.14094L5.15484 8.89832L5.11066 8.66972L5.0756 8.45585L5.04755 8.25881L5.02722 8.07789L5.01319 7.91451L5.00197 7.70414C4.94517 6.16427 6.12392 4.66787 7.48709 4.08446Z",
    fill: "#130D38"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#C31C00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 4,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#C31C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnHoldIcon);
export default __webpack_public_path__ + "static/media/on-hold-icon.f90642692524516e225eaeaf42f7a0b2.svg";
export { ForwardRef as ReactComponent };